import React from 'react';

var ArrowDown = function ArrowDown(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "M12 14.586L5.707 8.293a1 1 0 0 0-1.414 1.414l7 7a1 1 0 0 0 1.414 0l7-7a1 1 0 1 0-1.414-1.414L12 14.586z",
    fill: "currentColor",
    fillRule: "nonzero"
  }));
};

ArrowDown.defaultProps = {
  role: "img",
  viewBox: "0 0 24 24"
};
import iconHandler from './hoc';
export { ArrowDown as icon };
export default iconHandler(ArrowDown);


//////////////////
// WEBPACK FOOTER
// ./~/@jsluna/icons/dist/ArrowDown.js
// module id = 577
// module chunks = 0